import axios from 'axios';
import store from '@/store/Store';

// @ts-ignore
const API_URL = import.meta.env.VITE_API_URL;

export const fetchVastaanottoDetails = async (id) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(`${API_URL}/varaus/vastaanottoDetails/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchDashboardStats = async (date) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(`${API_URL}/varaus/stats`, {
    params: { date },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchKoriBySourceStats = async (start, end) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(`${API_URL}/kori/stats/source`, {
    params: {
      alku: start,
      loppu: end,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const updateAsArrived = async (id) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.post(`${API_URL}/varaus/vastaanotto/${id}/saapunut`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status !== 200) {
    throw new Error('Saapumismerkinnän asettaminen epäonnistui!');
  }
};

export const updateAsNotArrived = async (id) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.delete(`${API_URL}/varaus/vastaanotto/${id}/saapunut`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status !== 200) {
    throw new Error('Saapumismerkinnän poistaminen epäonnistui!');
  }
};

export const updateAsLeft = async (id) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.post(`${API_URL}/varaus/vastaanotto/${id}/lahtenyt`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status !== 200) {
    throw new Error('Lähtemismerkinnän asettaminen epäonnistui!');
  }
};

export const updateAsNotLeft = async (id) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.delete(`${API_URL}/varaus/vastaanotto/${id}/lahtenyt`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status !== 200) {
    throw new Error('Lähtemismerkinnän poistaminen epäonnistui!');
  }
};
